import { Injectable } from '@angular/core';
import {
    RouterStateSnapshot,
    ActivatedRouteSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromApp from '../store/app.reducer';
import { Actions, ofType } from '@ngrx/effects';
import { filter, map, switchMap, take } from 'rxjs/operators';
import * as AssignmentsActions from './assignments/store/assignments.actions';
import * as CompanyActions from './company/store/company.actions';
import moment from 'moment';

@Injectable({
    providedIn: 'root',
})
export class EmployeeResolverResolver {
    constructor(
        private store: Store<fromApp.AppState>,
        private actions$: Actions,
    ) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        switch (route.routeConfig.path) {
            case 'report/:id':
                return this.store
                    .pipe(
                        filter(state => state.auth.customer != null),
                        take(1),
                        switchMap(state => {
                            let report = state.assignments.reports.find(item => {
                                return item.id == route.params.id;
                            });
                            if (report) {
                                this.store.dispatch(new AssignmentsActions.LoadReportSuccess({ data: report }));
                                return of(true);
                            }
                            this.store.dispatch(new AssignmentsActions.LoadReport({
                                reportId: route.params.id,
                                customerId: state.auth.customer.id,
                            }));

                            return this.actions$.pipe(
                                ofType(AssignmentsActions.LOAD_REPORT_SUCCESS, AssignmentsActions.LOAD_REPORT_FAILED),
                                take(1),
                            );
                        }),
                    );
            case 'reports-details':
                this.store.select(state => state.auth).pipe(
                    filter((authState) => authState.customer !== null),
                    take(1),
                ).subscribe((authState) => {
                    if (authState.customer) {
                        this.store.dispatch(new AssignmentsActions.LoadReports({
                            customerId: authState.customer.id,
                            page: 1,
                            params: {},
                            fromTime: moment().subtract(1, 'month').startOf('month').unix(),
                            toTime: moment().subtract(1, 'month').endOf('month').unix(),
                        }));
                        this.store.dispatch(new AssignmentsActions.LoadReportsStatistics({
                            customerId: authState.customer.id,
                            fromTime: moment().subtract(1, 'month').startOf('month').unix(),
                            toTime: moment().subtract(1, 'month').endOf('month').unix(),
                            subBetween: 'subMonth',
                            isCustom: false,
                            skillIds: [],
                            jobPlaceIds: [],
                        }));
                    }
                });
                return this.actions$.pipe(
                    ofType(AssignmentsActions.LOAD_REPORTS_SUCCESS, AssignmentsActions.LOAD_REPORTS_FAILED),
                    take(1),
                );
            case 'assignments':
                return this.store.pipe(
                    filter(state => state.auth.authChecked === true),
                    take(1),
                    switchMap(state => {
                        if (!state.auth.customer) {
                            return of(true); // Unauthenticated: show blank calendar + Login
                        }
                        this.store.dispatch(new CompanyActions.LoadObjects({ customerId: state.auth.customer.id }));
                        this.store.dispatch(new AssignmentsActions.LoadAssignmentsStatistics());
                        return this.actions$.pipe(
                            ofType(CompanyActions.LOAD_OBJECTS_SUCCESS, CompanyActions.LOAD_OBJECTS_FAILED),
                            take(1),
                            map(() => true)
                        );
                    })
                );
            case 'users':
                this.store.select(state => state.auth).pipe(
                    filter((authState) => authState.customer !== null),
                    take(1),
                ).subscribe((authState) => {
                    if (authState.customer) {
                        this.store.dispatch(new CompanyActions.LoadEmployees({
                            customerId: authState.customer.id,
                            // page: 1,
                        }));
                    }
                });
                return this.actions$.pipe(
                    ofType(CompanyActions.LOAD_EMPLOYEES_SUCCESS, CompanyActions.LOAD_EMPLOYEES_FAILED),
                    take(1),
                );
        }
    }
}